module.exports = __webpack_public_path__ + "img/todown.5c8cf5ce.png";